import { createAction } from "redux-actions";
import {
  API,
  CLEAR_TOKEN,
  FAIL_AUTH,
  SUCCESS_AUTH,
} from "../constants/actionTypes";
import { apiPayloadCreator } from "../utils/appUtils";
import { login } from "../constants/labels";

const getToken = createAction(API, apiPayloadCreator);
export const clearTokenId = createAction(CLEAR_TOKEN);
export const getTokenId = (params, data, onSuccess) =>
  getToken({
    label: login,
    method: "POST",
    url: params,
    onSuccessWithoutDispatch: onSuccess,
    onSuccess: handleLoginSuccess,
    data: data,
    onFailure: handleLoginError,
  });

function handleLoginSuccess(token) {
  //token.credentials
  return {
    type: SUCCESS_AUTH,
    payload: token,
  };
}

function handleLoginError(error) {
  return {
    type: FAIL_AUTH,
    payload: error.data,
  };
}
